export default "__VITE_ASSET__6ecbe5fd__"